/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize TreatmentOptions List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './TreatmentOptionsListView';

export const mapStateToPropsTreatmentOptionsList = mapStateToProps;
export const mapDispatchToPropsTreatmentOptionsList = mapDispatchToProps;

export default connect(
  mapStateToPropsTreatmentOptionsList,
  mapDispatchToPropsTreatmentOptionsList
)(View);
